export default "__VITE_ASSET__Dv39y4s6__"